import React from 'react';
import footerTopShape from '../assets/footer-top-shape.png';

const SectionWave = ({ flip = false, priority = false, className = '' }) => (
  <div className={`section-wave ${className}`.trim()} aria-hidden="true">
    <img
      src={footerTopShape}
      alt=""
      width={2180}
      height={103}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      className={`section-wave__img${flip ? ' section-wave__img--flip' : ''}`}
    />
  </div>
);

export default SectionWave;
